import React, { useRef, useState } from "react";

const PlayIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><polygon points="6 3 21 12 6 21 6 3"/></svg>;
const PauseIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="white"><rect x="5" y="3" width="5" height="18" rx="1"/><rect x="14" y="3" width="5" height="18" rx="1"/></svg>;
const formatAudioTime = (s: number) => `0:${Math.max(0, Math.round(s || 0)).toString().padStart(2, "0")}`;

// Lecteur audio épuré — bouton play/pause + barre de progression + durée — repris à l'identique
// de CommentAudioPlayer (PostCard.tsx, commentaires vocaux) pour l'étape d'écoute avant envoi
// d'un message vocal (voir Composer.tsx : plus d'envoi automatique à l'arrêt de l'enregistrement).
export function VoicePreviewPlayer({ src }: { src: string }) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [current, setCurrent] = useState(0);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) a.pause(); else a.play().catch(() => {});
  };

  const progress = duration > 0 ? current / duration : 0;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 9, backgroundColor: "#F5F5F5", borderRadius: 20, padding: "6px 12px 6px 6px", maxWidth: 260 }}>
      <audio
        ref={audioRef} src={src} preload="metadata" style={{ display: "none" }}
        onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => setPlaying(false)}
        onLoadedMetadata={e => setDuration(e.currentTarget.duration || 0)}
        onTimeUpdate={e => setCurrent(e.currentTarget.currentTime)}
      />
      <button onClick={toggle} style={{ width: 26, height: 26, borderRadius: "50%", border: "none", backgroundColor: "#0a0a0a", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}>
        {playing ? <PauseIcon /> : <PlayIcon />}
      </button>
      <div style={{ flex: 1, height: 3, borderRadius: 2, backgroundColor: "#E0E0E0", overflow: "hidden", minWidth: 50 }}>
        <div style={{ height: "100%", width: `${Math.min(100, progress * 100)}%`, backgroundColor: "#0a0a0a" }} />
      </div>
      <span style={{ fontSize: 10.5, color: "#999", fontVariantNumeric: "tabular-nums", flexShrink: 0 }}>
        {formatAudioTime(playing || current > 0 ? current : duration)}
      </span>
    </div>
  );
}
